import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type IStore = {
  id: number
  name: string
  logo: string
  description?: string
  rate: number
  category: string[]
  products?: IStoreProduct[]
}

export type IStoreProduct = {
  id: number
  name: string
  price: number
  image?: string
  description?: string
}

export type ICartItem = {
  quantity: number
  id: number
  name: string
  price: number
}

interface CartState {
  items: ICartItem[]
  total: number
  animateCart: boolean
}

const initialState: CartState = {
  items: [],
  total: 0,
  animateCart: false
}

const cartSlice = createSlice({
  name: 'marketplaceCart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<ICartItem>) => {
      const itemIndex = state.items.findIndex(
        (item) => item.id === action.payload.id
      )
      if (itemIndex !== -1) {
        state.items[itemIndex].quantity += action.payload.quantity
      } else {
        state.items.push(action.payload)
      }
      state.total = parseFloat(state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      ).toFixed(2))
    },
    removeFromCart: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((item) => item.id !== action.payload)
      state.total = parseFloat(state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      ).toFixed(2))
    },
    updateQuantity: (
      state,
      action: PayloadAction<{ id: number; quantity: number }>
    ) => {
      const item = state.items.find((item) => item.id === action.payload.id)
      if (item && action.payload.quantity > 0) {
        item.quantity = action.payload.quantity
      }
      state.total = parseFloat(state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      ).toFixed(2))
    },
    setCartAnimation: (state) => {
      state.animateCart = true
    },
    resetCartAnimation: (state) => {
      state.animateCart = false
    },
    clearCart: () => initialState,
  },
})

export const {
  addToCart,
  updateQuantity,
  removeFromCart,
  clearCart,
  setCartAnimation,
  resetCartAnimation,
} = cartSlice.actions

export default cartSlice.reducer
